import { useState, useRef } from 'react'
import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { withTranslation, i18n } from 'server/i18n'

import PhoneSmallIcon from 'public/icons/phone-small.svg'
import MailIcon from 'public/icons/mail.svg'
import DropdownIcon from 'public/icons/dropdown.svg'
import MapSvg from './MapSvg'
import style from './ContactMap.style'

const ContactMapStyled = styled.div(props => ({ ...style(props) }))

const INFO_BY_COUNTRY = {
    'country-1': {
        id: 1,
        title: 'DEUTSCHLAND / BODENSEE',
        buttonTitle: 'Deutschland',
        addressLines: ['Merk & Merk GmbH', 'Argenweg 60/5', '88085 Langenargen'],
        contactLines: [
            { icon: <PhoneSmallIcon />, text: '+49 1751500915' },
            { icon: <MailIcon />, text: 'maik@merkandmerk.com' }
        ]
    },
    'country-2': {
        id: 2,
        title: 'SPANIEN / MALLORCA',
        buttonTitle: 'Spanien',
        addressLines: ['Merk & Merk SL', 'Cami Vell de Llucmajor 112', 'Platja de Palma, 07007 Palma'],
        contactLines: [
            { icon: <PhoneSmallIcon />, text: '+34 695470145' },
            { icon: <MailIcon />, text: 'office@merkandmerk.com' }
        ]
    },
    'country-3': {
        id: 3,
        title: 'KROATIEN',
        buttonTitle: 'Kroatien',
        addressLines: ['Merk & Merk Jahte Servis Tribunj d.o.o.', 'Jurjevgradska ul. 2', '22212 Tribunj'],
        contactLines: [
            { icon: <PhoneSmallIcon />, text: '+385(0)91 346 - 7775' },
            { icon: <MailIcon />, text: 'office@merkandmerk.com' }
        ]
    }
}

const countryIds = Object.keys(INFO_BY_COUNTRY)

const ContactMap = ({ t }) => {
    const [selectedCountry, setSelectedCountry] = useState(null)

    const handlePinMouseEnter = id => {
        setSelectedCountry(id)
    }

    const countryInfo = selectedCountry ? INFO_BY_COUNTRY[selectedCountry] : null
    const countryInfoRef = useRef(null)

    const handlePinClick = id => {
        setSelectedCountry(id)
        if (countryInfoRef.current) {
            const rect = countryInfoRef.current.getBoundingClientRect()
            const scrollTop = window.scrollY || window.pageYOffset
            const targetY = rect.top + scrollTop - 250

            window.scrollTo({
                top: targetY,
                behavior: 'smooth'
            })
        }
    }

    const handleCycleCountry = () => {
        if (selectedCountry === null) {
            setSelectedCountry(countryIds[0])
        } else {
            const idx = countryIds.indexOf(selectedCountry)
            const next = countryIds[(idx + 1) % countryIds.length]
            setSelectedCountry(next)
        }
    }

    return (
        <ContactMapStyled>
            <div className="Contact-map">
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                <div className="ContactMap-button" onClick={handleCycleCountry}>
                    {/* eslint-disable-next-line no-nested-ternary */}
                    {selectedCountry
                        ? INFO_BY_COUNTRY[selectedCountry].buttonTitle
                        : i18n.language === 'en'
                        ? 'Select country'
                        : 'Land auswählen'}
                    <div className="icon">
                        <DropdownIcon />
                    </div>
                </div>

                <MapSvg
                    selectedCountry={selectedCountry}
                    onPinMouseEnter={handlePinMouseEnter}
                    onPinClick={handlePinClick}
                />

                {countryInfo ? (
                    <div className="CountryInfo" ref={countryInfoRef}>
                        <h3 className="CountryInfo-title">{countryInfo.title}</h3>
                        <div className="CountryInfo-content">
                            <div>
                                <p>
                                    <strong>{t('address')}</strong>
                                </p>
                                {countryInfo.addressLines.map((line, idx) => (
                                    <div key={line.id}>{line}</div>
                                ))}
                            </div>
                            <div>
                                <p>
                                    <strong>{t('contact')}</strong>
                                </p>
                                {countryInfo.contactLines.map((item, idx) => (
                                    <div className="ContactItem-wrapper" key={item.id}>
                                        <p className="ContactItem-icon">{item.icon}</p>
                                        <p>{item.text}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="CountryInfo-placeholder" />
                )}
            </div>
        </ContactMapStyled>
    )
}

ContactMap.propTypes = {
    t: PropTypes.func.isRequired
}
export default withTranslation('common')(withTheme(ContactMap))
